/*
 * @Description: 文件流下载
 * @Author: yangsibo
 * @Date: 2022-10-25 20:52:23
 * @LastEditors: zhanghq
 * @LastEditTime: 2023-09-18 20:42:55
 * @FilePath: /xian.xiangli360.com/src/api/downloadRequest.js
 */

import axios from "axios";
import { base } from "./base";
import store from "@/store";
export const downloadRequest = ({ id, fileName, fileType }) => {
  axios({
    method: "get",
    url: base.request + "/contractTemp/downloadTemp?id=" + id,
    headers: {
      "Content-type": "application/json;charset:utf-8;",
      accessToken:
        store.state.accessToken || localStorage.getItem("accessToken"),
    },
    data: { id },
    responseType: "blob",
  })
    .then((res) => {
      const blob = new Blob([res.data]);
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName + fileType;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName + fileType);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 导出文件
export const exportFile = (data, fileName, fileType) => {
  const blob = new Blob([data]);
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName + "." + fileType;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName + "." + fileType);
  }
};